import { z } from 'zod';

/**
 * Primitivos de validacao compartilhados pelos DTOs.
 * Dinheiro e taxa: ENTRADA e SAIDA como string decimal. Nunca number.
 * Escalas batem com o schema: Decimal(18,6) para dinheiro/quantidade, Decimal(12,8) para taxa/fracao.
 */

const decimalRegex = (scale: number) =>
  new RegExp(`^\\d{1,12}(\\.\\d{1,${scale}})?$`);

/** Decimal nao negativo com ate `scale` casas (dinheiro/quantidade). */
export const dinheiro = z
  .string()
  .regex(decimalRegex(6), 'Decimal invalido (ate 6 casas, sem sinal, use ponto)');

/** Taxa em fracao (0.18 = 18%), ate 8 casas, nao negativa. */
export const taxa = z
  .string()
  .regex(decimalRegex(8), 'Taxa invalida (fracao, ate 8 casas, sem sinal, use ponto)');

// Id de entidade: cuid() gerado pela API, ou id deterministico do seed (xf_...). Aceita qualquer id seguro.
export const cuid = z.string().regex(/^[A-Za-z0-9_-]{1,64}$/, 'Id invalido');

export const isoDate = z.iso.date();

export const paginacao = z.object({
  limit: z.coerce.number().int().min(1).max(200).default(50),
  offset: z.coerce.number().int().min(0).default(0),
});

export const idParam = z.object({ id: cuid });

/** Valor finito com sinal opcional (Q29: frete e basePrice aceitam qualquer valor finito). */
export const valorFinito = z
  .string()
  .regex(/^-?\d{1,12}(\.\d{1,6})?$/, 'Decimal invalido (ate 6 casas, use ponto)');
